module.exports = __webpack_public_path__ + "a573d947ee7d0078fb04d18fd9ce60a1.png";